/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import {
    FETCH_BOOK_DETAILS_SUCCESS,
    CLEAR_BOOKDETAILS,
    GET_FRONT_COVER_PAGE_DETAILS_SUCCESS,
    GET_COVER_PAGE_THUMBNAILS_SUCCESS,
    CHANGE_TOC_NUMERATION,
    CHANGE_CHAPTER_HEADERS,
    CHANGE_FORCED_TRIMSIZE,
    CHANGE_HAS_REQUESTED_ACCESSCODE,
    CHANGE_TRIMSIZE
} from '../_actions/bookdetails.actions';

export const INITIAL_STATE = {
    forcedTrimSize: false,
    automaticPageNumbering: false,
    automaticIndexes: false,
    chapterHeaders: false,
    forcedRectoStart: false,
    accessCodeRequested: false,
    printTOCChapterType: '',
    thumbnailUrl: '',
    coverPageUrl: '',
    trimSize: '',
    pageCount: 0,
};

export function bookdetailsreducer (state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_BOOK_DETAILS_SUCCESS: {
            return {
                ...state,
                ...action.payload
            };
        }
        case CLEAR_BOOKDETAILS: {
            return INITIAL_STATE;
        }
        case GET_FRONT_COVER_PAGE_DETAILS_SUCCESS: {
            return {
                ...state,
                ...action.payload
            };
        }
        case GET_COVER_PAGE_THUMBNAILS_SUCCESS: {
            return {
                ...state,
                coverPageThumbnails: action.coverPageThumbnails
            };
        }
        case CHANGE_TOC_NUMERATION: {
            return  {
                ...state,
                printTOCChapterType: action.printTOCChapterType
            };
        }
        case CHANGE_CHAPTER_HEADERS: {
            return  {
                ...state,
                chapterHeaders: action.chapterHeaders
            };
        }
        case CHANGE_FORCED_TRIMSIZE: {
            return  {
                ...state,
                forcedTrimSize: action.forcedTrimSize
            };
        }
        case CHANGE_HAS_REQUESTED_ACCESSCODE: {
            return  {
                ...state,
                accessCodeRequested: action.accessCodeRequested
            };
        }
        case CHANGE_TRIMSIZE: {
            return {
                ...state,
                trimSize: action.trimSize
            };
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/bookdetails.reducer.js